<template>
  <ul class="g-layout-user-menu">
    <li v-if="userInfo && userInfo.user && userInfo.user.userName">
      <span>{{ userInfo.user.userName }}</span>
    </li>
    <li>
      <router-link to="/manage/my">
        <ins><Icon type="user2"/></ins>
        <span>{{ $t('com_header_account') }}</span>
      </router-link>
    </li>
    <li>
      <a href="javascript:;" @click="logout">
        <ins><Icon type="logout2"/></ins>
        <span>{{ $t('com_header_logout') }}</span>
      </a>
    </li>
  </ul>
</template>
<script>
import { LogoutSubmit } from '@/api/login';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    // 退出登录
    logout() {
      this.$confirm({
        title: this.$t('com_header_logout_confirm_text'),
        content: '',
        okText: this.$t('com_btn_confirm'),
        onOk: () => {
          this.$store.commit('setFreeze', true);
          LogoutSubmit()
            .then(res => {
              if (res.code === 0) {
                // 清除现有登录态
                this.$store.commit('clearSession', null);
                window.location.href = '/login';
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
        onCancel() {},
      });
    },
  },
};
</script>
<style lang="less" scoped>
.g-layout-user-menu {
  margin: 0;
  white-space: nowrap;
  padding: 10px 0 5px;
  width: 105px;

  li {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 36px;
    line-height: 36px;
    padding: 0;
    margin: 0;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);

    a {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      color: rgba(0, 0, 0, 0.88);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      height: 36px;
      line-height: 36px;
      padding: 12px 16px;
      white-space: nowrap;

      &:hover {
        color: @primary-color;
        background: rgba(0, 0, 0, 0.04);
      }

      ins {
        width: 16px;
        display: flex;
        overflow: hidden;
        margin-right: 5px;
        svg {
          width: 100%;
          color: rgba(0, 0, 0, 0.88);
        }
      }
      span {
        display: block;
        flex: 1;
      }
    }

    &:first-child {
      padding: 10px 5px 20px 20px;
      height: 20px;
      line-height: normal;
      text-align: center;
      display: flex;
      align-items: center;
      span {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
        font-size: 12px;
        color: #666;
      }

      a {
        margin-bottom: 10px;
      }
    }

    &:last-child {
      margin-top: 5px;
      border: none;
      a svg,
      a {
        color: #f5222d;
        margin-bottom: 0;
      }
    }
  }
}
</style>
